import { TemplateLibrary } from '@/lib/types/TemplateBuilder/templateTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TemplateState {
	error: string | null;
	isLoading: boolean;
	templates: TemplateLibrary[];
	privateTemplates: TemplateLibrary[];
	editTemplate: TemplateLibrary | null;
	templateBuilder: TemplateLibrary | null;
	organizationIdentifier: string | null;
	isTemplateClone: boolean;
	isTemplateEditable: boolean;
	editTemplateId: string | undefined;
	isTemplateSetupVisible: boolean;
	isTemplateDndVisible: boolean;
	templateTagOptions: any;
	templateTagFilter: string[];
	isNodeDragging: boolean;
}

const initialState: TemplateState = {
	isLoading: false,
	templates: [],
	privateTemplates: [],
	error: null,
	editTemplate: null,
	templateBuilder: null,
	organizationIdentifier: null,
	isTemplateClone: false,
	isTemplateEditable: false,
	editTemplateId: undefined,
	isTemplateSetupVisible: false,
	isTemplateDndVisible: false,
	templateTagOptions: [],
	templateTagFilter: [],
	isNodeDragging: false,
};

const templateSlice = createSlice({
	name: 'templates',
	initialState,
	reducers: {
		setTemplateData(state, action: PayloadAction<TemplateLibrary[]>) {
			state.templates = action.payload;
		},
		setPrivateTemplateData(state, action: PayloadAction<TemplateLibrary[]>) {
			state.privateTemplates = action.payload;
		},
		setEditTemplateData(state, action: PayloadAction<TemplateLibrary | null>) {
			state.editTemplate = action.payload;
		},
		buildTemplate(state, action: PayloadAction<TemplateLibrary | null>) {
			state.templateBuilder = action.payload;
		},
		setOrganizationIdentifier(state, action: PayloadAction<string | null>) {
			state.organizationIdentifier = action.payload;
		},
		setTemplateClone(state, action: PayloadAction<boolean>) {
			state.isTemplateClone = action.payload;
		},
		setTemplateEditable(state, action: PayloadAction<boolean>) {
			state.isTemplateEditable = action.payload;
		},
		setEditTemplateId(state, action: PayloadAction<string | undefined>) {
			state.editTemplateId = action.payload;
		},
		setTemplateSetupVisible(state, action: PayloadAction<boolean>) {
			state.isTemplateSetupVisible = action.payload;
		},
		setTemplateDndVisible(state, action: PayloadAction<boolean>) {
			state.isTemplateDndVisible = action.payload;
		},
		setTemplateTagOptions(state, action: PayloadAction<any[]>) {
			state.templateTagOptions = action.payload;
		},
		setLoading(state, action: PayloadAction<boolean>) {
			state.isLoading = action.payload;
		},
		setTemplateTagFilter(state, action: PayloadAction<string[]>) {
			state.templateTagFilter = action.payload;
		},
		setisNodeDragging(state, action: PayloadAction<boolean>) {
			state.isNodeDragging = action.payload;
		},
	},
});

export const {
	setTemplateData,
	setEditTemplateData,
	buildTemplate,
	setPrivateTemplateData,
	setOrganizationIdentifier,
	setTemplateClone,
	setTemplateEditable,
	setEditTemplateId,
	setTemplateDndVisible,
	setTemplateSetupVisible,
	setTemplateTagOptions,
	setLoading,
	setTemplateTagFilter,
	setisNodeDragging,
} = templateSlice.actions;
export default templateSlice.reducer;
